import { IconWrapper } from '../runtime';
export default IconWrapper('radish', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M37 23.2C37 32 24 44 24 44C24 44 11 32 11 23.2C11 15.9098 16.8203 10 24 10C31.1797 10 37 15.9098 37 23.2Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M24 4V10",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M18 5L22 10",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M30 5L26 10",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M12 20H20",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M29 27H36",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M16 34H22",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-miterlimit": "2",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M13.812 15C12.0515 17.2521 11 20.1014 11 23.2C11 28.7547 16.1797 35.5844 20 39.8663",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M37 23.2C37 25.9741 35.7082 29.0661 33.939 32",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap
    }
  })]);
});